export default __webpack_public_path__ + "3b4c3f4cfc5a1f2139e243fdbbcc9096.png";